import {addAuthToFetchOpts} from '../../config/queryopts'
import {useMutationWithAuthentication} from "../index";
import {apiUrlInternal} from "../../config/api"
import axios from "axios";
import {useQueryClient} from "react-query";


const _ = require('lodash');


export const EditTicketFetcher = (accessToken, params) => {
  return axios.put(
    `${apiUrlInternal}/tickets/assign/${params.uid}?user_uid=${params.user_uid}`, _.omit(params, ['uid']), addAuthToFetchOpts(accessToken, {})
  ).then(res => res);
}

export const useAssignUserTicketMutation = (fetcher = EditTicketFetcher) => {
  const queryClient = useQueryClient()
  return useMutationWithAuthentication(
    ['update-user-ticket'],
    (accessToken, params) => fetcher(accessToken, params),
    {
      onSuccess: (_, params) => {
        queryClient.invalidateQueries('update-user-ticket')
        queryClient.invalidateQueries(['tickets', `/${params.uid}`])
      }
    }
  )
}

